import { Link } from "react-router-dom"

export default function NotFound() {
    return (
        <div
            role="main"
            aria-labelledby="not-found-title"
            style={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "24px",
                background: "var(--bg)",
            }}
        >
            <div style={{ fontSize: "13px", fontWeight: 700, letterSpacing: "0.08em", color: "var(--blue-accent)", marginBottom: "16px" }}>
                404
            </div>
            <h1 id="not-found-title" style={{ fontSize: "28px", fontWeight: 800, color: "var(--navy)", marginBottom: "12px" }}>
                Page not found
            </h1>
            <p style={{ fontSize: "15px", color: "var(--text-3)", maxWidth: "420px", marginBottom: "28px" }}>
                The page you're looking for doesn't exist or may have moved. If you followed a link to a document
                or request, it may have expired.
            </p>
            <Link to="/" className="btn btn-blue-pill">
                Back to Trust Center
            </Link>
        </div>
    )
}
